import { render, staticRenderFns } from "./HistoryItemCardContent.vue?vue&type=template&id=b38ee6ec&scoped=true&"
import script from "./HistoryItemCardContent.vue?vue&type=script&lang=ts&"
export * from "./HistoryItemCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryItemCardContent.vue?vue&type=style&index=0&id=b38ee6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38ee6ec",
  null
  
)

export default component.exports